<template>
  <div class="poster-wrap">
    <div class="poster-bg">
      <div class="warp-content" :style="{width:pc_width_580 }">
        <img
          v-if="img_url"
          @click="$emit('poster-close')"
          class="poster-close"
          src="@/assets/images/doctor/poster_close.png"
          alt
        />
        <div v-if="!img_url" class="poster-content">
          <div class="poster-content-header">
            <img class="poster-content-logo" src="@/assets/images/doctor/poster_logo.png" alt />
            <span class="poster-content-title">医谱健康网</span>
            <div class="flex-1"></div>
            <span class="poster-content-popular-type">科普</span>
          </div>
          <div class="poster-content-wrap">
            <doctor-poster-production :data="data" v-if="is_production"></doctor-poster-production>
            <doctor-poster-popular :data="data" v-else></doctor-poster-popular>
          </div>
          <div class="poster-footer">
            <p
              class="poster-save"
            >{{img_url ? '长按海报保存到相册，即刻分享好友' : is_fail ? '生成失败，请稍后再试' : '海报生成中...'}}</p>
          </div>
        </div>

        <img class="poster-img" v-else :src="img_url" alt />
      </div>
      <ShareCommonFooter
        @shareWx="shareWx"
        @sharePyq="sharePyq"
        @cancle="$emit('poster-close')"
        @shareLink="$emit('poster-close')"
        :isShow="isShow"
        :isUrl="img_url"
        @shareCard="shareCard"
      ></ShareCommonFooter>
    </div>
  </div>
</template>

<script>
import ImgLoadListener from '@/js/ImageLoadListener'
import ShareCommonFooter from '../ShareCommonFooter'
import DoctorPosterPopular from './DoctorPosterPopular'
import DoctorPosterProduction from './DoctorPosterProduction'
import { NativeMessageShare } from '@/js/nativeBridge/nativeMessage'
import os from '@/js/pc'
export default {
    components: {
        DoctorPosterPopular,
        DoctorPosterProduction,
        ShareCommonFooter
    },
    props: {
        data: {
            type: Object,
            required: true,
            default: {}
        },
        is_production: Boolean
    },
    data() {
        return {
            imgListener: null,
            img_url: '',
            is_fail: false,
            isShow: true
        }
    },
    computed: {
        isInApp() {
            return navigator.userAgent.indexOf('YPAPP') !== -1
        },
        pc_width_580() {
            return os.isPC() ? '580px' : '100%'
        }
    },
    mounted() {
        //
    },
    methods: {
        shareWx() {
            if (!this.img_url) {
                this.$nativeBridge.sendMessage(
                    new NativeMessageShare(
                        {
                            link: `https://${window.location.host}/#/DoctorProduction?production_id=${this.$route.query.production_id}`,
                            title: this.data.title,
                            img: this.data.file_cover
                            // desc: this.data.article_content
                        },
                        'appMessage'
                    )
                )
            } else {
                this.$nativeBridge.sendMessage(new NativeMessageShare(this.img_url))
            }
            this.$emit('poster-close')
        },
        sharePyq() {
            if (!this.img_url) {
                this.$nativeBridge.sendMessage(
                    new NativeMessageShare(
                        {
                            link: `https://${window.location.host}/#/DoctorProduction?production_id=${this.$route.query.production_id}`,
                            title: this.data.title,
                            img: this.data.file_cover
                        },
                        'timeline'
                    )
                )
            } else {
                this.$nativeBridge.sendMessage(new NativeMessageShare(this.img_url, 'timeline'))
            }
            this.$emit('poster-close')
        },
        shareCard() {
            if (!this.isInApp) {
                this.isShow = false
            }

            this.addListener()
        },
        screenshots() {
            let self = this
            import('@/js/html2canvas.js').then(res => {
                res.default(document.querySelector('.poster-content'), {
                    useCORS: true,
                    allowTaint: false,
                    dpi: window.devicePixelRatio * 1,
                    scale: window.devicePixelRatio * 1
                })
                    .then(canvas => {
                        self.$nextTick(function() {
                            const url = canvas.toDataURL('image/png')
                            this.img_url = url
                        })
                    })
                    .catch(e => {
                        console.error('error--> ', e)
                    })
            })
        },
        addListener() {
            this.imgListener = new ImgLoadListener({
                node: '.poster-content',
                done: () => {
                    console.log('done')
                    this.screenshots()
                    this.is_fail = false
                },
                fail: () => {
                    console.log('fail')
                    this.is_fail = true
                }
            })
        },
        imgs_reload() {
            this.imgListener.reload()
        }
    }
}
</script>
<style scoped>
.poster-wrap {
    /* display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center; */
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1111;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.45);
}
.warp-content {
    flex: 1;
    justify-content: center;
    display: flex;
    overflow: hidden;
    flex-direction: column;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .poster-wrap {
        font-family: serif;
    }
}

.poster-bg {
    margin-top: 0.5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100%;
}

.poster-close {
    width: 0.68rem;
    height: 0.68rem;
    position: absolute;
    top: 0.96rem;
    right: 0.96rem;
    cursor: pointer;
}

.poster-content {
    margin: 0 auto;
    width: 15.5rem;
    position: relative;
    left: 1000rem;
}

.poster-img {
    width: 90%;
    /* height: 90%; */
    margin: 0 auto;
}

.poster-footer {
    margin-top: 0.62rem;
    width: 100%;
}

.poster-save {
    font-size: 0.6rem;
    text-align: center;
    color: #fefefe;
}

.poster-content-header {
    width: 100%;
    height: 1.45rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    background: white;
}

.poster-content-logo {
    margin-left: 0.85rem;
    width: 0.81rem;
    height: 0.81rem;
}

.poster-content-title {
    font-size: 0.51rem;
    color: #888888;
    margin-left: 0.25rem;
}

.poster-content-popular-type {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 1.71rem;
    height: 0.77rem;
    background-color: #ffdabf;
    border-radius: 0.38rem;
    font-size: 0.51rem;
    color: #df6123;
    margin-right: 0.64rem;
}

.poster-content-learning-type {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 1.71rem;
    height: 0.77rem;
    background-color: #ccd7ff;
    border-radius: 0.38rem;
    font-size: 0.51rem;
    color: #1244f1;
    margin-right: 0.64rem;
}

.poster-content-wrap {
    height: 22rem;
}

.flex-1 {
    flex: 1;
    width: 0;
}
</style>